export default "__VITE_ASSET__e3ec4e6a__"